import React from "react";
import { useEventContext } from "../../../context/EventContext";
import { formatFromDateDetails, formatTime } from "../../../exports/functions";
import useMobile from "../../../hooks/useMobile";
import useTab from "../../../hooks/useTab";

const AdminEvents = () => {
  const mobile = useMobile();
  const tab = useTab();
  const { eventData } = useEventContext();

  const today = new Date();

  const formatEventDate = (fullDate: string) => new Date(fullDate);

  const ongoingEvents = eventData
    ?.map((event) => ({
      ...event,
      attributes: {
        ...event,
        ...formatFromDateDetails(event?.from_date),
        Time: formatTime(event?.start_time),
      },
    }))
    ?.filter((event) => {
      const eventDate = formatEventDate(event.attributes.From_Full_Date);
      return eventDate < today;
    });
  const upcomingEvents = eventData
    ?.map((event) => ({
      ...event,
      attributes: {
        ...event,
        ...formatFromDateDetails(event?.from_date),
        Time: formatTime(event?.start_time),
      },
    }))
    ?.filter((event) => {
      const eventDate = formatEventDate(event.attributes.From_Full_Date);
      return eventDate >= today;
    });
  return (
    <section
      className="feature-two"
      style={{
        marginLeft: !mobile && !tab ? "240px" : "unset",
        backgroundColor: "unset",
      }}
    >
      <div className="container">
        <div className="feature-two__inner" style={{ marginTop: "unset" }}>
          <div className="row" style={{ justifyContent: "space-evenly" }}>
            <div className="col-xl-6 col-lg-6">
              <div
                className="feature-two__single wow fadeInUp custom-feature-two__single"
                data-wow-delay="200ms"
                style={{ height: "285px", overflow: "unset" }}
              >
                <div className="feature-two__img feature-two__img-2 custom-feature-two__img-2">
                  <div
                    className="table-responsive feature-two__content custom-feature-two__content"
                    style={{ height: "285px" }}
                  >
                    <h6 className="table-header">Upcoming Events</h6>
                    <div style={{ width: "100%", overflow: "auto" }}>
                      <table
                        className="table cart-table custom-cart-table custom-cart-event-cell"
                        style={{ marginBottom: "unset" }}
                      >
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Image</th>
                            <th>Title</th>
                            <th>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {upcomingEvents?.map((event, index) => (
                            <tr
                              key={index}
                              style={{
                                backgroundColor:
                                  index % 2 !== 0 ? "#f2f0ec" : "unset",
                              }}
                            >
                              <td>{index + 1}</td>
                              <td>
                                <div className="product-box">
                                  <div
                                    className="img-box"
                                    style={{ width: "80px" }}
                                  >
                                    <img
                                      src={
                                        event?.image[0]?.media?.url &&
                                        `${process.env.REACT_APP_cmsUrl}${event?.image[0]?.media?.url}`
                                      }
                                      alt="event-image"
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>{event?.event_name}</td>
                              <td>{event?.from_full_date}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div
                className="feature-two__single wow fadeInUp custom-feature-two__single"
                data-wow-delay="100ms"
                style={{ height: "285px", overflow: "unset" }}
              >
                <div className="feature-two__img feature-two__img-2 custom-feature-two__img-2">
                  <div
                    className="table-responsive feature-two__content custom-feature-two__content"
                    style={{ height: "285px" }}
                  >
                    <h6 className="table-header">Past Events</h6>
                    <div style={{ width: "100%", overflow: "auto" }}>
                      <table
                        className="table cart-table custom-cart-table custom-cart-event-cell"
                        style={{ marginBottom: "unset" }}
                      >
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Image</th>
                            <th>Title</th>
                            <th>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ongoingEvents?.map((event, index) => (
                            <tr
                              key={index}
                              style={{
                                backgroundColor:
                                  index % 2 !== 0 ? "#f2f0ec" : "unset",
                              }}
                            >
                              <td>{index + 1}</td>
                              <td>
                                <div className="product-box">
                                  <div
                                    className="img-box"
                                    style={{ width: "80px" }}
                                  >
                                    <img
                                      src={
                                        event?.image[0]?.media?.url &&
                                        `${process.env.REACT_APP_cmsUrl}${event?.image[0]?.media?.url}`
                                      }
                                      alt="event-image"
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>{event?.event_name}</td>
                              <td>{event?.from_full_date}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdminEvents;
